import React from "react";
import { Typography, Container, Box, Button } from "@mui/material";

import useLanguageHook from "containers/hooks/useLanguageHook";
import routeConfig from "@config/routes";
import { Link } from "react-router-dom";

function NotFoundPage() {
  const { t } = useLanguageHook();
  const locationPath = window.location.pathname;

  return (
    <Container maxWidth="sm">
      <Typography variant="h2">
        <strong>Error 404</strong>
      </Typography>
      <hr />
      <Typography>
        {t.UI.NotFound}: {locationPath}
      </Typography>
      <Box sx={{ height: 30 }} />
      <Button component={Link} size="large" variant="contained" color="primary" to={routeConfig.Application}>
        Back to TransparencyVis
      </Button>
    </Container>
  );
}

export { NotFoundPage };
